import React, { useEffect, useRef } from 'react'
import { Button, Loader } from 'is24-corecss'
import { useTranslation } from 'react-i18next'

import { InitState } from '../../../../redux/reducers/root/initialState'
import { Styles } from '../../../../@types/types'
import { useAppSelector } from '../../../../app/hooks'

export interface PreviewModalProps {
  onClose: () => void
}

const styles: Styles = {
  previewModalContent: {
    width: '100%',
    height: '80vh',
  },
  previewModal: {
    width: '100%',
    height: '80%',
  },
}

const PreviewModal: React.FC<PreviewModalProps> = ({ onClose }) => {
  const { t } = useTranslation()
  const formRef = useRef<HTMLFormElement>(null)
  const { previewData, previewModalIsOpen } = useAppSelector((state: InitState) => state.previewFeature)

  useEffect(() => {
    if (previewModalIsOpen && previewData) {
      formRef.current && formRef.current.submit()
    }
  }, [previewModalIsOpen, previewData])

  return (
    <div id='preview-model-content' style={styles.previewModalContent}>
      {!previewData && (
        <div className='grid grid-flex grid-justify-center' role='status'>
          <Loader size='large' />
        </div>
      )}
      <iframe
        id='previewModalFrame'
        name='previewModalFrame'
        style={styles.previewModal}
        title={t('previewModal.header', 'Preview')}
      />
      {previewData && (
        <form
          ref={formRef}
          id='previewForm'
          data-testid='previewFormTestId'
          action={previewData.url}
          method='post'
          target='previewModalFrame'
        >
          <input type='hidden' name='exposeDto' value={previewData.expose} />
          <input type='hidden' name='token' value={previewData.exposeToken} />
          <input type='hidden' name='realtorDto' value={previewData.realtor} />
          <input type='hidden' name='realtorToken' value={previewData.realtorToken} />
        </form>
      )}
      <div className='margin-top-s align-center'>
        <Button appearance='secondary' id='preview-close-button' onClick={onClose}>
          {t('previewModal.backButton', 'Close')}
        </Button>
      </div>
    </div>
  )
}

export default PreviewModal
